export const plansSelector = (state: RootState) => state.subscriptionAndPlans.plans;

export const plansStatusSelector = (state: RootState) => plansSelector(state).status;

export const planByIdSelector = (planId: number) => (state: RootState) =>
  plansSelector(state).data[planId];
